//@flow
import React from 'react';

type Props = {
  resetPasswordSuccess?:boolean,
  newUser:boolean,
  inReferral?:boolean,
  hideSignInOptions?:boolean,
  title?:string,
  subtitle?:string,
  displayLogin:() => void,
  displayCreateAccount:() => void,
};

export default function LoginFormHeader(props:Props) {
  if (props.resetPasswordSuccess) {
    return (
      <div>
        <h2>Awesome!</h2>
        <div className="header">Your password was successfully saved. Please sign in again below.</div>
      </div>
    );
  }
  if (props.newUser && props.inReferral) {
    return (
      <div>
        <div className="header referral">
          <div>Already a member? <a onClick={props.displayLogin}>Sign in</a></div>
        </div>
      </div>
    );
  }
  if (props.newUser) {
    const title = props.title || 'Create your account';
    return (
      <div>
        <h2>{title}</h2>
        {!props.hideSignInOptions &&
          <div className="header">Already a member? <a onClick={props.displayLogin}>Sign in</a></div>
        }
        {props.subtitle &&
          <p className="subtitle">
            {props.subtitle}
          </p>
        }
      </div>
    );
  }
  if (props.inReferral) {
    return (
      <div>
        <div className="header referral">
          <div>Not a member? <a onClick={props.displayCreateAccount}>Sign up</a></div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <h2>Sign in</h2>
      <div className="header">Not a member? <a onClick={props.displayCreateAccount}>Sign up</a></div>
    </div>
  );
}
